import React from "react";
import {
  getDecryptedToken,
  setEncryptedTokens,
} from "../../utils/crypto/cryptoUtils";
import "./Mart.scss";

export default function Marts() {
  const martArray: any[] = JSON.parse(getDecryptedToken("marts") ?? "[]");

  const [selectedMart, setSelectedMart] = React.useState<any>(null);
  const [martId, setmartId] = React.useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = Number(e.target.value);
    const selected = martArray.find((item: any) => item.id === selectedId);
    setmartId(e.target.value);
    setSelectedMart(selected);

    // Only set mart-specific fields here.
    // currency, companyId, and designation were already stored during login.
    setEncryptedTokens([
      { key: "selectedMartId", value: e.target.value },
      { key: "martName", value: selected?.name },
      { key: "address", value: selected?.address },
      { key: "phoneNumber", value: selected?.phoneNumber },
      { key: "isEmailShown", value: String(selected?.email ?? "") },
      { key: "registrationNumber", value: selected?.registerNumber || "" },
      { key: "logo", value: selected?.logo || "" },
      {
        key: "defaultTax",
        value: selected?.defaultTax != null ? String(selected.defaultTax) : "",
      },
      {
        key: "advancedDeletion",
        value: String(selected?.advancedDeletion || false),
      },
    ]);

    window.location.href = "/dashboard";
  };

  return (
    <div className="mart_center">
      <div className="mart_container">
        <h3>Select your Mart</h3>
        <p className="mart_subtitle">Select a mart to continue</p>

        <div className="box">
          {martArray.map((mart: any) => (
            <div key={mart.id} className="radio-option">
              <input
                type="radio"
                name="select"
                id={`option-${mart.id}`}
                value={mart.id}
                checked={martId === String(mart.id)}
                onChange={handleChange}
              />
              <label htmlFor={`option-${mart.id}`}>
                <div className="dot"></div>
                <div className="text">{mart.name}</div>
              </label>
            </div>
          ))}
        </div>

        {selectedMart && (
          <div className="popup">
            <div className="popup-content">
              <h4>
                Welcome to{" "}
                <span style={{ color: "darkblue" }}> {selectedMart.name} </span>
              </h4>
              <p>Address: {selectedMart.address}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
